import {useIntl} from 'react-intl'

const AmoCRMUsersInServiceHeader = () => {
  const intl = useIntl()

  return (
    <thead>
      <tr className='text-muted fs-9  text-center'>
        <th role='columnheader' className='min-w-70px text-end'>
          {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.USERS.ACTIVE'})}
        </th>
        <th role='columnheader' className='min-w-125px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.LINES.HEADER.USERID'})}
        </th>
        <th role='columnheader' className='min-w-225px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.USERS.NAME'})}
        </th>
        <th role='columnheader' className='min-w-125px px-0 required'>
          {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.USERS.NUMBER'})}
        </th>
        <th role='columnheader' className='min-w-100px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.LINES.HEADER.SMARTCALL'})}
        </th>
        <th role='columnheader' className='min-w-70px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.USERS.AA'})}
        </th>
        <th role='columnheader' className='min-w-70px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.USERS.MR'})}
        </th>
        <th role='columnheader' className='min-w-100px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.LINES.HEADER.EDIT'})}
        </th>
      </tr>
    </thead>
  )
}

export {AmoCRMUsersInServiceHeader}
